import { ExtendedBasketResponseModel } from '@beef/shop-cart-api';
import { createAction, createSlice } from '@reduxjs/toolkit';
import type { CartSlice } from '@carnica/smart-kit';

const initialState: CartSlice = {
  quantity: 0,
};

export const setQuantity = createAction(
  'cart/setQuantity',
  (cartData: ExtendedBasketResponseModel) => ({
    payload: cartData?.stats?.quantity || 0,
  }),
);

const cartSlice = createSlice({
  name: 'headerCart',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setQuantity, (state, { payload }) => {
      state.quantity = payload;
    });
  },
});

export default cartSlice.reducer;
